import React from 'react';
import { CircularProgress, TableCell, TableRow } from '@material-ui/core';

interface LoaderRowProps {
    itemHeight: number;
    itemsPerPage: number;
    columnCount: number;
}

const LoaderRow = ({ itemHeight, itemsPerPage, columnCount }: LoaderRowProps) => {
    return (
        <TableRow>
            <TableCell height={itemHeight * itemsPerPage} colSpan={columnCount} rowSpan={itemsPerPage} align='center'>
                <CircularProgress />
            </TableCell>
        </TableRow>
    );
};

export default LoaderRow;